import { render, staticRenderFns } from "./transcription-approve.vue?vue&type=template&id=f11cdef6&scoped=true&lang=pug&"
import script from "./transcription-approve.vue?vue&type=script&lang=ts&"
export * from "./transcription-approve.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11cdef6",
  null
  
)

export default component.exports